import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainLayout from "./components/layouts/MainLayout";
import routes from "./Routes";
import ScrollTop from "./components/ScrollTop";
import Login from "./components/common/Accounts/Login";
import Home from "./pages/Home";
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from "react";
// import { onMessageListener, requestFirebaseNotificationPermission } from "notifications/NotificationManager";

function App() {
  const [showMessage, setShowMessage] = useState(null);

  // useEffect(() => {
  //   requestFirebaseNotificationPermission().then((token) => {
  //     if (token) {
  //       console.log("Notification Token:", token);
  //     }
  //   });

  //   onMessageListener().then((payload) => {
  //     console.log("Foreground message received: ", payload);
  //     alert(payload?.notification?.title + ": " + payload?.notification?.body);
  //   });
  // }, []);

  return (

    <Router>
      <ScrollTop />
      <Routes>
        <Route path="/log-in" element={<Login />} />
        <Route path="" element={<MainLayout />}>
          {routes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
